import Thumbnail from './Thumbnail'
import { projects } from '../projects'

function MainGrid() {
  return (
    <section aria-label='Projects' className='mt-12 grid grid-cols-1 sm:grid-cols-2 items-stretch gap-8'>
      {projects.map((project) => (
        <Thumbnail key={project.slug} project={project} />
      ))}
    </section>
  )
}

export default MainGrid
